module.exports = __webpack_public_path__ + "img/gamma_background--small--transparent.7f439587.png";